import axios from "axios";
import React from "react";
import "react-notifications-component/dist/theme.css";
import authenticationService from "../auth/AuthenticationService";
import { handleResponse } from "../auth/handle-response";
import { url } from "../config/config";
import geolocationService from "../services/GeolocationService";
import "./BatchMaterialReport.css"; // Import CSS
import NotificationService from "../services/NotificationService";
import util from '../services/Utility';
import UserSetting from "../services/UserSetting";

class IssueForm extends React.Component {
  constructor(props) {
    super(props);
    const it = JSON.parse(localStorage.getItem("ITEM"));
    // console.log("ITEM " + JSON.stringify(it));
    var inQty = it.b_qty;
    var checkPass = inQty;
    this.state = {
      rowDetails: this.getRowDetails(it),
      qtyDetails: this.getQtyDetails(it),
      inQty: inQty,
      rate_qty: it.rate_qty > 0 ? it.rate_qty : 1,
      itemRemarks: it.remarks || "",
      checkPass: checkPass,
      jobRate: it.job_rate || 0,
      zeroBalkey: it.zeroBalkey,
      payForQty: this.zeroBalkey === false ? checkPass : 0,
      notes: it.from_remarks || "",
      balance: inQty - checkPass,
      job: "",
      jobsMap: new Map(),
      isWorkerDisabled: true,
      isJobDisabled: false,
      isGetWorkerDisabled: false,
      isIssueFurtherDisabled: false,
      workers: [],
      worker: "",
      latitude: null,
      longitude: null,
      errorLocation: false,
    };
  }

  // Lifecycle method for when component is unmounted
  componentWillUnmount() {
    // Replace history when the user leaves the IssueForm page
    clearInterval(this.disTimerID);
    this.props.history.replace("/");
  }

  componentDidMount() {
    if (localStorage.getItem("UserSetting")==null) {
      NotificationService.error("Something Wrong! Login Again...")
      return;
    }
    // Check if the form was previously submitted
    if (localStorage.getItem("isIssued") === "true") {
      this.cancelAction();
      return; // Stop further execution in componentDidMount
    }
    UserSetting.setSettings(JSON.parse(util.decodeString(localStorage.getItem("UserSetting"))));
    const res = JSON.parse(localStorage.getItem("response"));
    // console.log("Get Issue Success response " + JSON.stringify(res));

    const jobsMap = new Map();
    var flexible = true;
    res.forEach((job) => {
      if (job.initialProcess === false && job.ids === "M") {
        flexible = false;
      }
      jobsMap.set(job.job_id, job);
    });

    if (flexible) {
      jobsMap.set(0, { value: "Issued to finished stock", job_id: 0 });
    }
    this.setState({ jobsMap });
    this.isValidDistanceTimer();
  }

  isValidDistanceTimer = () => {
    this.disTimerID = setInterval(() => {
      authenticationService.isValidDistance();
    }, 10000); // Update timer every Minute
  };

  updateItemRemarks(value) {
    this.setState({ itemRemarks: value });
  }

  handleChange = (event) => {
    const { name, value } = event.target;

    this.setState((prevState) => {
      const newState = { ...prevState, [name]: value };

      // Check if the job selector is being changed
      if (name === "job") {
        const selectedJob = prevState.jobsMap.get(parseInt(value));
        if (selectedJob && selectedJob.value === "Issued to finished stock") {
          newState.isWorkerDisabled = true;
          newState.isGetWorkerDisabled = true;
          newState.workers = [];
        } else {
          newState.isGetWorkerDisabled = false;
        }
      }

      if (name === "checkPass") {
        const checkPass = value.trim() === "" ? 0 : parseFloat(value);

        // Ensure checkPass is not greater than the balance
        if (checkPass > prevState.inQty) {
          NotificationService.error("Qty cannot be greater than balance qty.");
          newState.checkPass = prevState.inQty;
          newState.balance = 0;
        } else {
          newState.balance = prevState.inQty - checkPass;
        }
      }

      if (name === "checkPass" && prevState.zeroBalkey === false) {
          newState.payForQty = newState.checkPass;
      }

      if (name === "payForQty") {
        const payForQty = value.trim() === "" ? 0 : parseFloat(value);

        // Ensure checkPass is not greater than the balance
        if (payForQty > newState.checkPass) {
          NotificationService.error("Pay for qty must be less than qty.");
          newState.payForQty = newState.checkPass;
        }
      }

      return newState;
    });
  };

  getRowDetails(bmrItemRow) {
    return `${bmrItemRow.client_lot_No}-${bmrItemRow.client_batch_no}
     [${bmrItemRow.worker_name}] ${bmrItemRow.item_name}
     [${bmrItemRow.type_id > 0 ? bmrItemRow.flagMessage : ""},
      ${bmrItemRow.style_id > 0 ? bmrItemRow.failMessage : ""}] `;
  }

  getQtyDetails(bmrItemRow) {
    return `Qty: ${util.getRoundOff(bmrItemRow.qty - bmrItemRow.job_rate, true)}
     Bal Qty: ${util.getRoundOff(bmrItemRow.b_qty, true)}`;
  }

  getCordinates() {
    this.setState({ isIssueFurtherDisabled: true });
    geolocationService
      .getCurrentLocation()
      .then((location) => {
        // Check if component is still mounted before updating state
        // console.log("latitude:" + location.latitude);
        // console.log("longitude:" + location.longitude);
        this.setState({
          latitude: location.latitude,
          longitude: location.longitude,
        });
        this.submitAction();
      })
      .catch((error) => {
        this.setState({ errorLocation: error });
      });
  }

  makeIssueSlipData(item) {
    return {
      item_id: item.item_id,
      type_id: item.type_id,
      style_id: item.style_id,
      ag_tran_id: item.tran_id,
      fromWorkerId: item.worker_id,
      fromMachineId: 0,
      fromJobId: item.job_id,
      agBatchNo: item.rows,
      rate_qty: this.state.jobRate > 0 ? this.state.rate_qty : 0,
      qty: item.b_qty,
      job_rate: this.state.jobRate,
      pay_for_qty: this.state.payForQty,
      tfd_qty: this.state.checkPass,
      balance_qty: this.state.balance,
      rate: parseFloat(item.messageId),
      remarks: this.state.itemRemarks,
      lot_name: item.lot_name,
      art_no: item.artNo,
    };
  }

  makeCreateIssueSlip() {
    const item = JSON.parse(localStorage.getItem("ITEM"));
    // console.log("item: " + item);
    return {
      img_path: item.oldName,
      from_dep_id: item.to_dep_id,
      from_batch_no: item.batch_id,
      order_id: item.order_id,
      order_no: item.order_no,
      prev_batch: item.prev_batch,
      barcode_data: null,
      issueSlipData: [this.makeIssueSlipData(item)],
      chNo: "",
      grossWt: "",
      remarks: this.state.notes,
      from_machine_id: item.fr_mach_id,
      fromJobId: item.from_job_id,
      to_dep_id: this.state.jobsMap.get(parseInt(this.state.job)).dep_id,
      job_id: this.state.jobsMap.get(parseInt(this.state.job)).job_id,
      lot_no: item.lot_id,
      lotNoForClient: item.client_lot_No,
      process_id: item.process_id,
      issued_to_job_or_check: item.job_quality,
      worker_id: this.getSelectedWorkerId(),
      machine_id: 0,
      process_tran_id: item.process_tran_id,
      slip_type: "Q",
      date: Date.now(),
      moduleName: "PRD",
      lotName: item.lot_name,
      artNo: item.artNo,
    };
  }

  // Function to get the selected worker ID
  getSelectedWorkerId = () => {
    const selectedWorker = this.state.workers.find(
      (worker) => worker.id === this.state.worker
    );
    return selectedWorker ? selectedWorker.id : 0;
  };

  async cancelAction() {
    localStorage.removeItem("isIssued"); // Clear the flag to prevent loop
    window.history.back();
  }

  async submitAction() {
    this.setState({ isIssueFurtherDisabled: false });
    if (this.state.job == null) {
      NotificationService.error("Job Is mandatory!");
      return;
    }
    if (this.state.worker == null) {
      NotificationService.error("Worker is mandatory !");
      return;
    }
    if (this.state.checkPass === null || this.state.checkPass === 0) {
      NotificationService.error("Qty cannot be empty or 0!");
      return;
    }
    if (this.state.payForQty > this.state.checkPass) {
      NotificationService.error("Pay Qty cannot more less than Qty!");
      return;
    }

    const requestBody = this.makeCreateIssueSlip();
    // console.log("requestBody: " + JSON.stringify(requestBody));

    await axios
      .post(`${url}prod/issueQualitySlip`, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          key: authenticationService.getAuthToken(),
          latitude: this.state.latitude,
          longitude: this.state.longitude,
          phone: authenticationService.getMobileNo(),
        },
      })
      .then(handleResponse)
      .then((res) => {
        let notificationTimer = 4000;
        // console.log("ISSUE FROM Res: " + JSON.stringify(res));
        const responseId = res.responseId;
        // console.log("responseId: " + responseId);
        authenticationService.addTime();
        let message = "";
        let type = "";
        localStorage.setItem("isIssued", "true");
        if (responseId === 168) {
          this.setState({ isIssueFurtherDisabled: true });
          // } else {
          //   this.setState({ isIssueFurtherDisabled: false });
        }
        switch (responseId) {
          case 168:
            message = "Success";
            type = "success";
            notificationTimer = 1000;
            // Delay closing the window
            setTimeout(() => {
              this.cancelAction();
            }, 1200);
            break;
          case 167:
            message = "Slip Data Not Found";
            type = "danger";
            break;
          case 378:
            message = "Date is less than the last batch number.";
            type = "warning";
            break;
          case 172:
            message =
              "Updation Failed for work in process in case of quality check.";
            type = "danger";
            break;
          case 213:
            message = "Tran Rate Not found";
            type = "warning";
            break;
          default:
            message = "Unknown response";
            type = "danger";
        }

        // Show the notification based on responseId
        if (type === "success") {
          NotificationService.success(message, notificationTimer);
        } else {
          NotificationService.error(message, notificationTimer);
        }
      })
      .catch((error) => {
        NotificationService.error("Request failed");
        console.error("Error:", error);
      });
  }

  async getWorkersAction() {
    // Check if a job is selected
    if (!this.state.job || this.state.job === "") {
      alert("Please select a job before fetching workers.");
      return;
    }
    this.setState({ isJobDisabled: true });
    // console.log("Selected JOB: " + this.state.job);
    // console.log(
    //   "Selected JOB DEP_ID: " +
    //     this.state.jobsMap.get(parseInt(this.state.job)).dep_id
    // );

    await axios
      .post(`${url}prod/getWorkersForDep`, null, {
        params: {
          key: authenticationService.getAuthToken(),
          dep_id: this.state.jobsMap.get(parseInt(this.state.job)).dep_id,
        },
      })
      .then(handleResponse)
      .then((res) => {
        // console.log("getWorkersForDep Res: " + JSON.stringify(res));
        if (res != null && res.length > 0) {
          const workerMap = res
            .replace(/[{}]/g, "")
            .split(", ")
            .map((item) => {
              const [id, name] = item.split("=");
              return { id, name };
            })
            .sort((a, b) => a.name.localeCompare(b.name)); // Sort based on name
          this.setState({ workers: workerMap, isWorkerDisabled: false });
        } else {
          NotificationService.error("No Worker Found");
          return;
        }
      })
      .catch((error) => {
        NotificationService.error("Request failed");
        console.error("Error:", error);
      });
  }

  render() {
    return (
      <div>
        <div className="container-md my-2 d-flex flex-column align-items-center">
          <div className="d-flex justify-content-center">
            <h2 className="text-center font-weight-bold responsive-heading">
              Quality Check Memo
            </h2>
          </div>
          <div className="d-flex justify-content-center mt-2">
            <h5 className="text-center font-weight-bold responsive-heading">
              {this.state.rowDetails}
            </h5>
          </div>
          <div className="d-flex justify-content-center mt-2">
            <h5 className="text-center font-weight-bold responsive-heading">
              {this.state.qtyDetails}
            </h5>
          </div>
        </div>

        <div className="container-md">
          <div className="row my-2">
            <div className="col-md-3">
              <label>Job</label>
              <select
                className="form-control"
                name="job"
                disabled={this.state.isJobDisabled}
                onChange={this.handleChange}>
                <option value="">Select Job</option>
                {Array.from(this.state.jobsMap.values()).map((job) => (
                  <option key={job.job_id} value={job.job_id}>
                    {job.value}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-3 d-flex align-self-end">
              <button
                type="getWorkers"
                className="btn btn-primary"
                disabled={this.state.isGetWorkerDisabled}
                onClick={(e) => this.getWorkersAction()}>
                Get Workers
              </button>
            </div>
          </div>
          <div className="row my-2">
            <div className="col-md-3">
              <label>Worker</label>
              <select
                className="form-control"
                name="worker"
                disabled={this.state.isWorkerDisabled}
                onChange={this.handleChange}>
                <option value="">Select Worker</option>
                {this.state.workers.map((worker) => (
                  <option key={worker.id} value={worker.id}>
                    {worker.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="row my-2 align-items-center">
            <div className="col-md-2">
              <label>Qty</label>
              <input
                className="form-control"
                name="checkPass"
                value={this.state.checkPass}
                onChange={this.handleChange}
              />
            </div>
            <div className="col-md-2">
              <label>Balance</label>
              <input
                className="form-control"
                name="balance"
                value={util.getRoundOff(this.state.balance, false)}
                readOnly={true}
              />
            </div>
          </div>
          <div className="row my-2 align-items-center">
            <div className="col-md-2">
              <label>Pay for Qty</label>
              <input
                className="form-control"
                name="payForQty"
                value={this.state.payForQty}
                readOnly={!UserSetting.canChangePayForQty()}
                onChange={this.handleChange}
              />
            </div>
            <div className="col-md-2">
              <label>Job rate</label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  className="form-control"
                  name="jobRate"
                  value={this.state.jobRate}
                  readOnly={!UserSetting.canModifyJobRate()}
                  onChange={this.handleChange}
                  style={{ flex: 1 }} // Makes the input take up available space
                />
                <label style={{ marginLeft: "8px" }}>
                  {"/ " + this.state.rate_qty}
                </label>
              </div>
            </div>
          </div>
          <div className="row my-2">
            <div className="col-md-3">
              <label>Remarks</label>
              <input
                className="form-control"
                name="itemRemarks"
                value={this.state.itemRemarks}
                onChange={this.handleChange}
                readOnly={!UserSetting.canModifyRemarks()}
                onBlur={(e) => {
                  this.updateItemRemarks(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="row my-2">
            <div className="col-md-3">
              <label>Slip Notes</label>
              <input
                className="form-control"
                name="notes"
                value={this.state.notes}
                readOnly={!UserSetting.canModifySlipNotes()}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="row m-3">
            <div className="col-md-3">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={this.state.isIssueFurtherDisabled}
                onClick={(e) => this.getCordinates()}>
                Issue Further
              </button>
              <button
                type="button"
                className="btn btn-secondary ml-2"
                onClick={(e) => this.cancelAction()}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IssueForm;
